import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c8192182")

_pushScopeId("data-v-c8192182")
const _hoisted_1 = { class: "wrapper_header flex_space_center draggable" }
const _hoisted_2 = { class: "logo_box flex_space_center" }
const _hoisted_3 = {
  key: 0,
  class: "old_account_title"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 与极光PDF账号不互通 ")
const _hoisted_5 = { class: "active_container" }
const _hoisted_6 = { class: "active flex_column_center_start" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "如需登录极光PDF", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("请 ")
const _hoisted_9 = { class: "flex_space_center" }
const _hoisted_10 = { class: "feedback hover_feedback" }
const _hoisted_11 = { class: "wrapper_qrcode" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, "微信扫码 联系客服", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RetainDialog = _resolveComponent("RetainDialog")!
  const _component_AccountManage = _resolveComponent("AccountManage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          src: _ctx.viewModel.logo,
          class: "logo_icon",
          alt: ""
        }, null, 8, ["src"]),
        _createVNode("span", null, _toDisplayString(_ctx.viewModel.title) + "-会员中心", 1),
        (_ctx.viewModel.productId === String(_ctx.product_id_info.pdf) && _ctx.isShowOldAccount)
          ? (_openBlock(), _createBlock("span", _hoisted_3, [
              _hoisted_4,
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("span", null, [
                    _hoisted_8,
                    _createVNode("span", {
                      class: "underline",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.switchOldAccountLogin && _ctx.switchOldAccountLogin(...args)))
                    }, "切换登录方式")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_9, [
        (_ctx.viewModel.isLogin)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "common_btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickLogout && _ctx.clickLogout(...args)))
            }, "退出登录"))
          : _createCommentVNode("", true),
        (_ctx.showManageAccount)
          ? (_openBlock(), _createBlock("button", {
              key: 1,
              class: "common_btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickManageAccount(true)))
            }, "账号管理"))
          : _createCommentVNode("", true),
        (_ctx.showExchange)
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              class: "common_btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickExchange && _ctx.clickExchange(...args)))
            }, "兑换码"))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("img", {
              src: _ctx.viewModel.headerQrCodeImg,
              class: "qr_img",
              alt: ""
            }, null, 8, ["src"]),
            _hoisted_12
          ])
        ]),
        _createVNode("span", {
          class: "btn_close",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickClose && _ctx.clickClose(...args)))
        })
      ]),
      (_ctx.isShowDialog)
        ? (_openBlock(), _createBlock(_component_RetainDialog, {
            key: 0,
            onPaySuccess: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowDialog = false))
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.viewModel.isShowAccountManage)
          ? (_openBlock(), _createBlock(_component_AccountManage, {
              key: 0,
              onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clickManageAccount(false)))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
})